import React, { useState, useEffect, useMemo } from "react";
import { Collapse, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import themeDetails from "../../getThemeDetails";
import constants from "../../config/constants";
import { useSelector } from "react-redux";

const SubMenu = (props) => {
	const {
		icon,
		name,
		items,
		logoName,
		flag,
		itemsData = [],
		service,
		displayService,
		handlepath
	} = props;
	const [collapsed, setCollapsed] = useState(true);
	const login = useSelector(({ login }) => login);
	const [getMapArr, setGetMapArr] = useState([]);
	const [getMapArrAdmin, setGetMapArrAdmin] = useState([])


	const walletSetting = useSelector(({ walletSetting }) => walletSetting);
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authTokens = partnerloginUser.data.AuthToken;
	// sessionStorage.setItem("walletOwnerId", partnerloginUser.data.partnerId);


	const getMappedListRes = useSelector(
		({ getMappedList }) => getMappedList
	);

	const getMappedListForAdminRes = useSelector(
		({ getMappedListsForadmins }) => getMappedListsForadmins
	)
	console.log("resDatapartner", getMappedListRes)
	console.log("resData", getMappedListForAdminRes)
	const toggle = () => setCollapsed((collapsed) => !collapsed);
	const Theme = useSelector((state) => state.theme.theme);


	const role = login?.data?.Role?.toLowerCase() || "";
	const subRole = login?.data?.subRole || "";

	// Ensure module data is available
	const moduleData = getMappedListForAdminRes?.data?.moduleAllocationVO || {};
	const { masterModuleMappingList = [], masterSubModuleMappingList = [] } = moduleData;


	const getMappedListFunc = () => {
		if (getMappedListRes.data.status === "success" && getMappedListRes.data.moduleAllocationVO && getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList) {
			setGetMapArr(getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList);
		}
		if (getMappedListRes.data.status === "failed") {
			setGetMapArr([]);
		}
	};

	useEffect(() => {
		getMappedListFunc();
	}, [getMappedListRes.data.status]);

	// const getMappedListForAdminsFunc = () => {
	// 	if (getMappedListForAdminRes.data.status === "success" && getMappedListForAdminRes.data.moduleAllocationVO && getMappedListForAdminRes.data.moduleAllocationVO.masterSubModuleMappingList) {
	// 		setGetMapArrAdmin(getMappedListForAdminRes.data.moduleAllocationVO.masterSubModuleMappingList);
	// 	}
	// 	if (getMappedListForAdminRes.data.status === "failed") {
	// 		setGetMapArrAdmin([]);
	// 	}
	// };

	// useEffect(() => {
	// 	getMappedListForAdminsFunc();
	// }, [getMappedListForAdminRes.data.status]);


	// useEffect(() => {
	// 	if(getMapArrAdmin){
	// 		getMappedListForAdminsFunc();
	// 	}

	// }, [getMapArrAdmin,getMappedListForAdminRes.data.status]);

	// useEffect(() => {
	// 	if (getMappedListRes?.data?.status === "success" && getMappedListRes?.data?.moduleAllocationVO?.masterSubModuleMappingList) {
	// 		setGetMapArr(getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList);
	// 	} else {
	// 		setGetMapArr([]);
	// 	}
	// }, [getMappedListRes?.data?.status]);

	// useEffect(() => {
	// 	if (getMappedListForAdminRes?.data?.status === "success" && getMappedListForAdminRes?.data?.moduleAllocationVO?.masterSubModuleMappingList) {
	// 		setGetMapArrAdmin(getMappedListForAdminRes.data.moduleAllocationVO.masterSubModuleMappingList);
	// 	} else {
	// 		setGetMapArrAdmin([]);
	// 	}
	// }, [getMappedListForAdminRes?.data?.status]);

	// useEffect(() => {
	// 	const mappingList = getMappedListRes?.data?.moduleAllocationVO?.masterSubModuleMappingList;
	// 	if (getMappedListRes?.data?.status === "success" && Array.isArray(mappingList)) {
	// 		setGetMapArr(mappingList.map((item) => item.toLowerCase())); // Convert all to lowercase
	// 	} else {
	// 		setGetMapArr([]);
	// 	}
	// }, [getMappedListRes?.data?.status]);
	console.log("Dasasas", getMapArr)

	console.log("DATs", getMapArrAdmin)
	// **Admin Mapping List**
	// useEffect(() => {

	// 	const mappingListAdmin = getMappedListForAdminRes?.data?.moduleAllocationVO?.masterSubModuleMappingList;
	// 	if (getMappedListForAdminRes?.data?.status === "success" && Array.isArray(mappingListAdmin)) {
	// 		setGetMapArrAdmin(mappingListAdmin.map((item) => item.toLowerCase())); // Convert all to lowercase
	// 	} else {
	// 		setGetMapArrAdmin([]);
	// 	}
	// }, [getMappedListForAdminRes?.data?.status]);



	if (service !== displayService) {
		return null;
	}




	return (
		<div>

			{login.data.Role.toLowerCase() === "owner" && items.map((item) => {
				if (
					getMappedListRes.success && getMappedListRes.data.moduleAllocationVO && getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList &&
					getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(item.flag) || item.flag === "DASHBOARD"
				) {
					return (
						<NavItem key={item.path}>
							<NavLink
								tag={Link}
								to={item.path}
								onClick={() => handlepath(item.path)}
								style={{ display: props.navStatus ? "" : "block" }}
							>
								<i className={item.icon}>
									<img
										src={`${process.env.PUBLIC_URL}/${Theme}/${item.logoName}.png`}
										alt={item.icon}
									/>
								</i>
								<span
									style={{
										display: props.navStatus ? "block" : "none",
										transition: "all 0.6s",
										marginTop: "9px"
									}}
								>
									{item.name}
								</span>
							</NavLink>
						</NavItem>
					);
				}
				return null; // Add this return statement to avoid React warning for array.map
			})}


			{login.data.Role.toLowerCase() === "admin"
				&& login.data.subRole === "" &&
				items.map((item) => {

					return (
						<NavItem key={item.path}>
							<NavLink
								tag={Link}
								to={item.path}
								onClick={() => handlepath(item.path)}
								style={{ display: props.navStatus ? "" : "block" }}
							>
								<i className={item.icon}>
									<img
										src={`${process.env.PUBLIC_URL}/${Theme}/${item.logoName}.png`}
										alt={item.icon}
									/>
								</i>
								<span
									style={{
										display: props.navStatus ? "block" : "none",
										transition: "all 0.6s",
										marginTop: "9px"
									}}
								>
									{item.name}
								</span>
							</NavLink>
						</NavItem>
					);

					return null; // Add this return statement to avoid React warning for array.map
				})}

			{/* {login.data.Role.toLowerCase() === "admin" && login.data.subRole === "" &&
			(
				<>
				<h1>hello</h1>
				</>
			)
			} */}



			{/* {login.data.Role.toLowerCase() === "admin" && login.data.subRole === "SubAdmin" &&
			(
				<>
				<h1>subadmin</h1>
				</>
			)
			} */}

			{/* 
			{login.data.partnerId !== "owner" && items.map((item) => {
				return (
					<NavItem key={item.path}>
						<NavLink
							tag={Link}
							to={item.path}
							onClick={() => handlepath(item.path)}
							style={{ display: props.navStatus ? "" : "block" }}
						>
							<i className={item.icon}>
								<img
									src={`${process.env.PUBLIC_URL}/${Theme}/${item.logoName}.png`}
									alt={item.icon}
								/>
							</i>
							<span
								style={{
									display: props.navStatus ? "block" : "none",
									transition: "all 0.6s",
									marginTop: "9px"
								}}
							>
								{item.name}
							</span>
						</NavLink>
					</NavItem>
				);
			})}  */}



			{login.data.Role.toLowerCase() === "admin" && login.data.subRole === "SubAdmin"
				&& items.map((itemn) => {
					if (
						getMappedListForAdminRes.success && getMappedListForAdminRes.data.moduleAllocationVO && getMappedListForAdminRes.data.moduleAllocationVO.masterSubModuleMappingList &&
						getMappedListForAdminRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(itemn.flag) || itemn.flag === "DASHBOARD"
					) {
						return (
							<NavItem key={itemn.path}>
								<NavLink
									tag={Link}
									to={itemn.path}
									onClick={() => handlepath(itemn.path)}
									style={{ display: props.navStatus ? "" : "block" }}
								>
									<i className={itemn.icon}>
										<img
											src={`${process.env.PUBLIC_URL}/${Theme}/${itemn.logoName}.png`}
											alt={itemn.icon}
										/>
									</i>
									<span
										style={{
											display: props.navStatus ? "block" : "none",
											transition: "all 0.6s",
											marginTop: "9px"
										}}
									>
										{itemn.name}
									</span>
								</NavLink>
							</NavItem>
						);
					}
					return null; // Add this return statement to avoid React warning for array.map
				}
				)}



			{/* {login.data.Role=== "DEALER" && items.map((item) => {
				if (
					getMappedListRes.success && getMappedListRes.data.moduleAllocationVO && getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList &&
					getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(item.flag) || item.flag === "DASHBOARD"
				) {
					return (
						<NavItem key={item.path}>
							<NavLink
								tag={Link}
								to={item.path}
								onClick={() => handlepath(item.path)}
								style={{ display: props.navStatus ? "" : "block" }}
							>
								<i className={item.icon}>
									<img
										src={`${process.env.PUBLIC_URL}/${Theme}/${item.logoName}.png`}
										alt={item.icon}
									/>
								</i>
								<span
									style={{
										display: props.navStatus ? "block" : "none",
										transition: "all 0.6s",
										marginTop: "9px"
									}}
								>
									{item.name}
								</span>
							</NavLink>
						</NavItem>
					);
				}
				return null; // Add this return statement to avoid React warning for array.map
			})} */}

			{/* {login.data.Role.toLowerCase() === "DEALER" && items.map((item) => {

				return (
					<NavItem key={item.path}>
						<NavLink
							tag={Link}
							to={item.path}
							onClick={() => handlepath(item.path)}
							style={{ display: props.navStatus ? "" : "block" }}
						>
							<i className={item.icon}>
								<img
									src={`${process.env.PUBLIC_URL}/${Theme}/${item.logoName}.png`}
									alt={item.icon}
								/>
							</i>
							<span
								style={{
									display: props.navStatus ? "block" : "none",
									transition: "all 0.6s",
									marginTop: "9px"
								}}
							>
								{item.name}
							</span>
						</NavLink>
					</NavItem>
				);

				return null; // Add this return statement to avoid React warning for array.map
			})}   */}

			{/* {login.data.Role.toLowerCase() != "admin" && items.map((itemd) => {
				return (
					<NavItem key={itemd.path}>
						<NavLink
							tag={Link}
							to={itemd.path}
							onClick={() => handlepath(itemd.path)}
							style={{ display: props.navStatus ? "" : "block" }}
						>
							<i className={itemd.icon}>
								<img
									src={`${process.env.PUBLIC_URL}/${Theme}/${itemd.logoName}.png`}
									alt={itemd.icon}
								/>
							</i>
							<span
								style={{
									display: props.navStatus ? "block" : "none",
									transition: "all 0.6s",
									marginTop: "9px"
								}}
							>
								{itemd.name}
							</span>
						</NavLink>
					</NavItem>
				);
			})}  
			  */}

			{/* 			
{login.data.Role.toLowerCase() === "dealer" && items.map((item) => {

return (
	<NavItem key={item.path}>
		<NavLink
			tag={Link}
			to={item.path}
			onClick={() => handlepath(item.path)}
			style={{ display: props.navStatus ? "" : "block" }}
		>
			<i className={item.icon}>
				<img
					src={`${process.env.PUBLIC_URL}/${Theme}/${item.logoName}.png`}
					alt={item.icon}
				/>
			</i>
			<span
				style={{
					display: props.navStatus ? "block" : "none",
					transition: "all 0.6s",
					marginTop: "9px"
				}}
			>
				{item.name}
			</span>
		</NavLink>
	</NavItem>
);

return null; // Add this return statement to avoid React warning for array.map
})}   */}

		</div>
	);
};

export default SubMenu;
